import { render, staticRenderFns } from "./GoodReceiveCreate.vue?vue&type=template&id=66effa09&scoped=true&"
import script from "./GoodReceiveCreate.vue?vue&type=script&lang=js&"
export * from "./GoodReceiveCreate.vue?vue&type=script&lang=js&"
import style0 from "./GoodReceiveCreate.vue?vue&type=style&index=0&id=66effa09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66effa09",
  null
  
)

export default component.exports